module.exports = __webpack_public_path__ + "static/Hazy-fdd105439b82b3527fdac56174ceaf83.jpg";